import headerSocialIconsActiveRule from '../../../common/algorithms/header-social-icons-active-rule';

const dark = (params) => headerSocialIconsActiveRule(params);

export default dark;
